import { useNavigate } from "react-router-dom";
import { Sparkles, ChevronRight } from "lucide-react";
import { usePlan } from "@/components/ProBadge";
import { useT } from "@/i18n/I18nContext";

const fill = (s, vars) => Object.entries(vars).reduce((a, [k, v]) => a.replaceAll(`{${k}}`, String(v)), s);

/** Dashboard card for Basic users: how many of the free monthly AI actions
    are already used (5-segment bar). Tapping opens the subscription page. */
export default function AiQuotaChip() {
  const plan = usePlan();
  const navigate = useNavigate();
  const { t } = useT();
  if (!plan || plan.plan === "pro" || plan.ai_limit == null) return null;
  const total = plan.ai_limit;
  const used = Math.min(total, plan.ai_used || 0);
  const left = total - used;
  return (
    <button
      type="button"
      onClick={() => navigate("/app/abo")}
      data-testid="ai-quota-chip"
      className="w-full rounded-2xl border border-[#E8951C]/25 bg-[#FFF7EB] dark:bg-[#2a2116] dark:border-[#E8951C]/20 px-4 py-3 text-left active:scale-[0.99] transition"
    >
      <div className="flex items-center gap-2.5">
        <Sparkles className="h-4 w-4 text-[#E8951C] shrink-0" />
        <span className="flex-1 text-xs font-semibold text-[#8a5a10] dark:text-[#f0c079]">{t("cliDash.aiQuotaTitle")}</span>
        <span className="text-xs font-bold text-[#8a5a10] dark:text-[#f0c079]" data-testid="ai-quota-used">
          {fill(t("cliDash.aiQuotaUsed"), { used, total })}
        </span>
        <ChevronRight className="h-4 w-4 text-[#E8951C]/60 shrink-0" />
      </div>
      <div className="mt-2 flex gap-1" aria-hidden="true">
        {Array.from({ length: total }).map((_, i) => (
          <span key={i} className={`h-1.5 flex-1 rounded-full ${i < used ? "bg-[#E8951C]" : "bg-[#E8951C]/20"}`} />
        ))}
      </div>
      <p className="mt-1.5 text-[11px] text-[#8a5a10]/80 dark:text-[#f0c079]/70">
        {left > 0 ? fill(t("cliDash.aiQuotaLeftShort"), { n: left }) : t("cliDash.aiQuotaNoneLeft")}
        <span className="font-semibold"> · {t("cliDash.aiQuotaPro")}</span>
      </p>
    </button>
  );
}
